import { render, staticRenderFns } from "./OpsBrandManagement.vue?vue&type=template&id=41657395&"
import script from "./OpsBrandManagement.vue?vue&type=script&lang=js&"
export * from "./OpsBrandManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports